export default "__VITE_ASSET__DHlijxaq__"